import { render, staticRenderFns } from "./PostAnalysis.vue?vue&type=template&id=281e54c9&"
import script from "./PostAnalysis.vue?vue&type=script&lang=js&"
export * from "./PostAnalysis.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports